// Alpine
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
window.Alpine = Alpine;
Alpine.plugin(collapse);

// Popups Cookies
import Cookies from 'js-cookie';
Alpine.data("notice", () => ({
    show: true,
    init() {
      const cookieSet = Cookies.get("hide_notice");
  
      if (!cookieSet) {
        console.log("cookie not set");
        this.show = true;
      } else {
        console.log("cookie set");
        this.show = false;
      }
    },
    close() {
      this.show = false;
      Cookies.set("hide_notice", true, { expires: 7});
    }
}));

Alpine.start();

var allCookies = Cookies.get();
console.log(allCookies);

// Swiper core version + navigation, pagination modules:
import Swiper, { Navigation, EffectFade, Autoplay } from 'swiper';

// init Swiper:
const swiper = new Swiper('.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, EffectFade, Autoplay],
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: true
    },
    speed: 1500,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// Gallery Filter Buttons
const filterContainer = document.querySelector(".gallery-filter"),
filterSelect = document.querySelector(".gallery-filter-select"),
galleryItems = document.querySelectorAll(".gallery-item"),
galleryDiv = document.querySelector(".block-gallery");

if (galleryItems) {
    
    galleryItems.forEach((item) =>{
        swiper.autoplay.stop();
        item.addEventListener('click', function (e) {
            var index = item.dataset.loop;
            console.log(index);
            e.preventDefault();
            swiper.slideTo(index, 1500);
            galleryDiv.scrollIntoView();
        });
    });
}

if (filterContainer, filterSelect) {

    filterContainer.addEventListener("click", (event) =>{
        if(event.target.classList.contains("filter-item")){
            // deactivate existing active 'filter-item'
            filterContainer.querySelector(".active").classList.remove("active");
            // activate new 'filter-item'
            event.target.classList.add("active");
            const filterValue = event.target.getAttribute("data-filter");
            galleryItems.forEach((item) =>{
                if(item.classList.contains(filterValue) || filterValue === 'all'){
                    item.classList.remove("hide");
                        item.classList.add("show");
                }
                else{
                    item.classList.remove("show");
                    item.classList.add("hide");
                }
            });
        }
    });
  
    filterSelect.addEventListener("change", function(e) {
        const selectValue = this.value;
        console.log(selectValue);
  
        galleryItems.forEach((item) =>{
            if(item.classList.contains(selectValue) || selectValue === 'all'){
                item.classList.remove("hide");
                item.classList.add("show");
            }
            else{
                item.classList.remove("show");
                item.classList.add("hide");
            }
        });
  });
}

// Lightbox
import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    Toolbar: false,
    dragToClose: false,

    showClass: 'fancybox-fadeIn',
    hideClass: 'fancybox-fadeOut',

    closeButton: "inside",

    Image: {
        click: "close",
        wheel: "slide",
        zoom: false,
        fit: "cover",
    },

    Thumbs: {
        minScreenHeight: 0,
    },

    template: {
        // Close button icon
        closeButton:
            '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L26 26" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M26 1L1 26" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/></svg>',
        // Loading indicator icon
        spinner:
            '',
    },

    on: {
        initLayout: (fancybox) => {
            // Pass in close icon color overlay
            var iconColorClass = fancybox.options.target.dataset.color
            fancybox.$container.classList.add(iconColorClass)
            console.log(fancybox);
        },
    }
});

// When the user scrolls down and there is an active notice, adjust the nav offset
const notice = document.querySelector(".notice"),
target = document.querySelector(".main").offsetTop + 10;
if (notice) {
    function scrollFunction() {    
        if (document.body.scrollTop > target || document.documentElement.scrollTop > target) {
            notice.classList.add('hideMe');
        } else {
            notice.classList.remove('hideMe');
        }
    }
    window.onscroll = function() {
        scrollFunction()
    };
}

// Scrollto Animations
import AOS from 'aos';
AOS.init();

// animations on bg images
import simpleParallax from 'simple-parallax-js';
const images = document.getElementsByClassName('paraImage');
new simpleParallax(images, {
    scale: 1.2,
    overflow: true,
    orientation: 'down',
});

// Datepicker on Floorplans
import flatpickr from 'flatpickr';

flatpickr(".flatpickr", {
    minDate: "2023-04-01",
    altInput: true,
    altFormat: "M j Y",
    dateFormat: "U",
    monthSelectorType: "static",
    disableMobile: true,
});
